"use client"

import { getSiteUrl } from "@repo/shared"
import Image from "next/image"
import Link from "next/link"

import GradientText from "../../../../GradientText"

/**
 * MetalMind 链接组件
 */
export function MetalMindLink() {
  return (
    <Link href={getSiteUrl("ai")} className="mobileNavItem aiLink" target="_blank">
      <Image src={`https://imgqn.smm.cn/static/image/metal/ai-logo.svg`} alt="logo" width={20} height={20} />
      <GradientText
        className="mobileAiText"
        colors={["#5227FF", "#FF9FFC", "#B19EEF"]}
        animationSpeed={4}
        showBorder={false}
      >
        Metrix
      </GradientText>
    </Link>
  )
}
